var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgClose = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 15,
  height: 15,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#767571",
  d: "M.586 10.757a2 2 0 1 0 2.828 2.829l3.758-3.758 3.485 3.486a2 2 0 1 0 2.829-2.829L10 7l3.314-3.314A2 2 0 1 0 10.485.858L7.172 4.17 3.586.586A2 2 0 0 0 .758 3.414L4.343 7z"
})));
export default SvgClose;